<header class="topbar">

  <div>

    <span class="topbar-label">
      Gerenciamento
    </span>

    <h1>
      Cupons de desconto
    </h1>

    <p>
      Crie e gerencie os cupons utilizados nas reservas.
    </p>

  </div>

  <button
    type="button"
    class="btn-novo"
    (click)="novoCupom()"
  >
    + Novo cupom
  </button>

</header>


<section class="cupons-section">

  @if (carregando) {

    <div class="loading">
      Carregando cupons...
    </div>

  } @else if (cupons.length === 0) {

    <div class="estado-vazio">

      <div class="vazio-icone">
        %
      </div>

      <h2>
        Nenhum cupom cadastrado
      </h2>

      <p>
        Crie seu primeiro cupom de desconto.
      </p>

      <button
        type="button"
        class="btn-novo"
        (click)="novoCupom()"
      >
        Criar cupom
      </button>

    </div>

  } @else {

    <div class="cupons-grid">

      @for (cupom of cupons; track cupom.id) {

        <article class="cupom-card">

          <div class="cupom-topo">

            <div>

              <span class="cupom-id">
                Cupom #{{ cupom.id }}
              </span>

              <h3>
                {{ cupom.codigo }}
              </h3>

            </div>

            <span
              class="status"
              [class.ativo]="cupom.ativo"
              [class.inativo]="!cupom.ativo"
            >
              {{ cupom.ativo ? 'Ativo' : 'Inativo' }}
            </span>

          </div>


          @if (cupom.descricao) {

            <div class="cupom-descricao">

              <span>
                Descrição
              </span>

              <strong>
                {{ cupom.descricao }}
              </strong>

            </div>

          }


          <div class="cupom-dados">

            <!-- ACOMODAÇÕES -->

            <div>

              <span>
                Acomodações
              </span>

              <strong>

                @for (
                  quarto of cupom.quartos;
                  track quarto.id;
                  let ultimo = $last
                  ) {

                  {{ quarto.nome }}

                  @if (!ultimo) {
                    ,
                  }

                }

              </strong>

            </div>


            <!-- DESCONTO -->

            <div>

              <span>
                Desconto
              </span>

              <strong class="desconto">
                {{ formatarDesconto(cupom) }}
              </strong>

            </div>


            <!-- INÍCIO -->

            <div>

              <span>
                Início
              </span>

              <strong>
                {{ cupom.dataInicio | date:'dd/MM/yyyy' }}
              </strong>

            </div>


            <!-- FIM -->

            <div>

              <span>
                Fim
              </span>

              <strong>
                {{ cupom.dataFim | date:'dd/MM/yyyy' }}
              </strong>

            </div>

          </div>


          <!-- UTILIZAÇÕES -->

          <div class="cupom-utilizacoes">

            <span>
              Utilizações
            </span>

            <strong>

              {{ cupom.quantidadeUtilizacoes }}

              @if (cupom.limiteUtilizacoes) {

                / {{ cupom.limiteUtilizacoes }}

              } @else {

                / ∞

              }

            </strong>

          </div>


          <!-- AÇÕES -->

          <div class="cupom-acoes">

            <button
              type="button"
              class="btn-acao editar"
              (click)="editar(cupom)"
            >
              Editar
            </button>

            <button
              type="button"
              class="btn-acao status-btn"
              (click)="alterarStatus(cupom)"
            >
              {{ cupom.ativo ? 'Desativar' : 'Ativar' }}
            </button>

            <button
              type="button"
              class="btn-acao excluir"
              (click)="excluir(cupom)"
            >
              Excluir
            </button>

          </div>

        </article>

      }

    </div>

  }

</section>


<!-- ===================================================== -->
<!-- MODAL -->
<!-- ===================================================== -->

@if (modalAberto) {

  <div
    class="modal-overlay"
    (click)="fecharModal()"
  >

    <div
      class="modal"
      (click)="$event.stopPropagation()"
    >

      <!-- CABEÇALHO DO MODAL -->

      <div class="modal-header">

        <div>

          <h2>
            {{ editando ? 'Editar cupom' : 'Novo cupom' }}
          </h2>

        </div>

        <button
          type="button"
          class="fechar"
          (click)="fecharModal()"
        >
          ×
        </button>

      </div>


      <!-- FORMULÁRIO -->

      <form
        #form="ngForm"
        (ngSubmit)="salvar()"
      >

        <!-- CÓDIGO -->

        <div class="campo">

          <label for="codigo">
            Código
          </label>

          <input
            id="codigo"
            type="text"
            name="codigo"
            [(ngModel)]="formulario.codigo"
            placeholder="Ex.: PARAISO10"
            maxlength="50"
            required
          >

        </div>


        <!-- DESCRIÇÃO -->

        <div class="campo">

          <label for="descricao">
            Descrição
          </label>

          <input
            id="descricao"
            type="text"
            name="descricao"
            [(ngModel)]="formulario.descricao"
            placeholder="Ex.: 10% para primeira reserva"
            maxlength="255"
          >

        </div>


        <!-- ACOMODAÇÕES -->

        <div class="campo">

          <label>
            Acomodações
          </label>

          <div class="acomodacoes-lista">

            @for (quarto of quartos; track quarto.id) {

              <label class="acomodacao-option">

                <input
                  type="checkbox"
                  [checked]="
                    formulario.quartosIds.includes(quarto.id)
                  "
                  (change)="
                    toggleQuarto(
                      quarto.id,
                      $any($event.target).checked
                    )
                  "
                >

                <span>
                  {{ quarto.nome }}
                </span>

              </label>

            }

          </div>


          @if (formulario.quartosIds.length === 0) {

            <small class="campo-erro">
              Selecione pelo menos uma acomodação.
            </small>

          }

        </div>


        <!-- TIPO + VALOR -->

        <div class="linha">

          <div class="campo">

            <label for="tipoDesconto">
              Tipo de desconto
            </label>

            <select
              id="tipoDesconto"
              name="tipoDesconto"
              [(ngModel)]="formulario.tipoDesconto"
              required
            >

              <option value="PERCENTUAL">
                Percentual (%)
              </option>

              <option value="VALOR_FIXO">
                Valor fixo (R$)
              </option>

            </select>

          </div>


          <div class="campo">

            <label for="valorDesconto">
              Valor do desconto
            </label>

            <input
              id="valorDesconto"
              type="number"
              name="valorDesconto"
              [(ngModel)]="formulario.valorDesconto"
              min="0.01"
              step="0.01"
              required
            >

          </div>

        </div>


        <!-- DATAS -->

        <div class="linha">

          <div class="campo">

            <label for="dataInicio">
              Data de início
            </label>

            <input
              id="dataInicio"
              type="date"
              name="dataInicio"
              [(ngModel)]="formulario.dataInicio"
              required
            >

          </div>


          <div class="campo">

            <label for="dataFim">
              Data de fim
            </label>

            <input
              id="dataFim"
              type="date"
              name="dataFim"
              [(ngModel)]="formulario.dataFim"
              required
            >

          </div>

        </div>


        <!-- LIMITE -->

        <div class="campo">

          <label for="limiteUtilizacoes">
            Limite de utilizações
          </label>

          <input
            id="limiteUtilizacoes"
            type="number"
            name="limiteUtilizacoes"
            [(ngModel)]="formulario.limiteUtilizacoes"
            min="1"
            placeholder="Deixe vazio para ilimitado"
          >

        </div>


        <!-- ATIVO -->

        <label class="checkbox">

          <input
            type="checkbox"
            name="ativo"
            [(ngModel)]="formulario.ativo"
          >

          <span>
            Cupom ativo
          </span>

        </label>


        <!-- AÇÕES DO MODAL -->

        <div class="modal-acoes">

          <button
            type="button"
            class="btn-cancelar"
            (click)="fecharModal()"
          >
            Cancelar
          </button>

          <button
            type="submit"
            class="btn-salvar"
            [disabled]="
              form.invalid ||
              formulario.quartosIds.length === 0
            "
          >
            {{ editando ? 'Salvar alterações' : 'Criar cupom' }}
          </button>

        </div>

      </form>

    </div>

  </div>

}
